module.exports = __webpack_public_path__ + "img/fiskeriakvakultur_smvf.28435582.jpg";